/**
 * Map POI / school pin colors (default vs selected, hover, list hover).
 * Consumed by mvt-poimarker, mvt-schoolmarker; re-exported from mvt-newmap.js + property-poi.js.
 */
export const POI_MARKER_PALETTE = {
    grocery: { default: '#CB3FE1', selected: '#751B84' },
    cafes: { default: '#806BF9', selected: '#2D20DC' },
    parks: { default: '#1BB81F', selected: '#0C710E' },
    restaurants: { default: '#C8602E', selected: '#6E3519' },
};

export const SCHOOL_MARKER_PALETTE = {
    default: '#1CB1B7',
    selected: '#0C6C71',
};
